import React from 'react';
import useQuery from '../../../useQuery';
import {isSet} from '../../../utility';

const useCoupon = ({state, setLandMetas}) => {
    const {landId = 0} = useQuery();
    const [code, setCode] = React.useState();
    React.useEffect(() => {
        if (isSet(code)) {
            setLandMetas([{index: landId, code}]);
        } else {
            setLandMetas(null);
        }
    }, [code, state]);
    const setCodeCallback = React.useCallback((val) => {
        setCode(val);
    }, [setCode]);

    return {
        setCode: setCodeCallback
    }
};

export default useCoupon;
